// src/utils/generalUtils.js
// src/utils/generalUtils.js
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase/firebase";
/**
 * Generate a company ID from a name + the already-loaded companies list.
 *
 * @param {string} name               - company name
 * @param {Array<{companyId:string}>} companies - list of existing companies
 * @returns {string}                  - e.g. "REN001"
 */
export const generateCompanyId = (name, companies = []) => {
  const cleaned = String(name || "").trim();

  const words = name.trim().split(/\s+/);
  let initials;
  if (words.length >= 2) {
    initials = words
      .slice(0, 3)
      .map((w) => w[0].toUpperCase())
      .join("");
  } else {
    initials = name.substring(0, 3).toUpperCase();
  }

  while (initials.length < 3 && name.length > 0) {
    const randomChar =
      name[Math.floor(Math.random() * name.length)].toUpperCase();
    initials += randomChar;
  }

  // ── 2. Find the highest number currently used for THIS prefix ─────────
  // If you want a global running counter across all prefixes, drop the
  // prefix filter and just take max across all companies.
  let maxNum = 0;
  for (const c of companies) {
    const id = c?.companyId || "";
    if (!id.startsWith(initials)) continue;

    // handles "REN001" AND "REN-001"
    const m = id.match(/(\d+)$/);
    if (m) maxNum = Math.max(maxNum, parseInt(m[1], 10));
  }

  const nextNum = maxNum + 1;
  const padded = String(nextNum).padStart(3, "0");

  return `${initials}${padded}`;
};
/**
 * One-off fetcher for the approval path where a fresh read is wanted.
 * Use generateCompanyId() instead if you already have the list in memory.
 */
export const fetchCompaniesForIdGen = async () => {
  const q = query(
    collection(db, "companies"),
    orderBy("companyId", "desc"),
    limit(500), // safety cap
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};